import { TApplicationState } from '../../types/redux';

export const selectCompilations = (state: TApplicationState) => {
  return state.newbuildingRecommendations.compilations.slice(0, 2);
};
